import api from '../../services/api';

export const fetchDraftRegulations = async () => {
  const response = await api.get(`/regulationDrafts/my`);

  if (!response) {
    throw new Error('Failed to fetch Organization Unit Lists');
  }

  return response.data;
};

export const fetchDraftRegulationById = async (id: number | string | undefined | null) => {
  const response = await api.get(`/regulationDrafts/${id}`);
  if (!response) {
    throw new Error('Failed to fetch Organization Unit List');
  }

  return response.data;
};

export const createDraftRegulation = async (data: FormData) => {
  const response = await api.post(`/regulationDrafts`, data);
  if (!response) throw new Error('Failed to create draft regulation');
  return response.data;
};

export const updateDraftRegulation = async (data: FormData) => {
  const response = await api.put(`/regulationDrafts`, data);
  if (!response) throw new Error('Failed to create draft regulation');
  return response.data;
};

export const deleteDraftRegulation = async (id: string) => {
  const response = await api.delete(`/regulationDrafts/${id}`);
  if (!response) throw new Error('Failed to delete draft regulation');
  return response.data;
};

export const requestPublishRegulation = async ({
  id,
  data,
}: {
  id: string | undefined;
  data: { requestMessage: string };
}) => {
  const response = await api.post(`/regulations/${id}/requestPublication`, data);
  if (!response) throw new Error('Failed to request publish regulation');
  return true;
};

export const confirmPublishRegulation = async ({
  id,
  data,
}: {
  id: string | undefined;
  data: {
    title: string | null;
    requestMessage: string | null;
    distributionLists: number[] | null;
    isBodyHtml: boolean;
  };
}) => {
  const response = await api.post(`/regulations/${id}/approvePublicationRequest`, data);
  if (!response) throw new Error('Failed to approve publish regulation');
  return response.data;
};

export const requestDeleteRegulation = async ({
  id,
  data,
}: {
  id: string | undefined;
  data: { declinedMessage: string };
}) => {
  const response = await api.post(`/regulations/${id}/rejectPublishRequest`, data);
  if (!response) throw new Error('Failed to request publish regulation');
  return true;
};